const MESSAGING_WORKER_PATH = '/firebase-messaging-sw.js';

const isMessagingWorker = (registration: ServiceWorkerRegistration): boolean => (
	[registration.active, registration.waiting, registration.installing].some((worker) => (worker?.scriptURL ?? '').includes(MESSAGING_WORKER_PATH))
);

// takes push out of this browser for this site - at sign-out, and for anyone push is not for: every push subscription
// is ended, and the messaging worker, which serves nothing else, is unregistered, including one an older registration
// left under a scope of its own. it needs none of the fcm sdk, so a browser push is not for never downloads it
export const unsubscribeFromPush = async (): Promise<void> => {
	if (!('serviceWorker' in navigator)) {
		return;
	}

	const registrations = await navigator.serviceWorker.getRegistrations();
	for (const registration of registrations) {
		const pushSubscription = await registration.pushManager?.getSubscription();
		if (pushSubscription !== null && pushSubscription !== undefined) {
			await pushSubscription.unsubscribe();
		}
		if (isMessagingWorker(registration)) {
			await registration.unregister();
		}
	}
};
